import { useQuery } from '@tanstack/react-query';

import Client from './client';
import { QUERY_KEYS } from './query-keys';

import type { UseQueryOptions } from '@tanstack/react-query';

export const useUserMe = (
  options: Omit<
    UseQueryOptions<Awaited<ReturnType<typeof Client.fetchUserMe>>>,
    'queryFn' | 'queryKey'
  > = {},
) => {
  const { data, status, error, isLoading, refetch } = useQuery({
    queryKey: [QUERY_KEYS.ME],
    queryFn: () => Client.fetchUserMe(),
    refetchInterval: false,
    retry: false,
    ...options,
  });

  return {
    userMe: data?.data?.data ?? null,
    getUserMeStatus: status,
    getUserMeError: error,
    isGetUserMeLoading: isLoading,
    refetchUser: refetch,
  };
};
